import React, { useEffect, useState } from 'react';
import axios from 'axios';
import trainingsApi from 'utils/trainingsApi';
import { navigate } from 'gatsby';
import { Modal } from 'antd';
import {
  useElements,
  useStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from '@stripe/react-stripe-js';
import appConfig from '../utils/appConfig';
import { Elements } from '@stripe/react-stripe-js';
import { PaymentElement } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
const stripePromise = loadStripe(appConfig.publishableKey);



const ErrorMessage = ({ children }) => (
  <ul className="card-errors">
    <li>{children}</li>
  </ul>
);

const CARD_OPTIONS = {
  style: {
    base: {
      '::placeholder': {
        color: '#fff',
      },
    },
  },
};

const Affirm = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const training = props.training;
  const discount = props.discount;
  const [error, setError] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [isBtnClicked, setBtnClicked] = useState(false);
  const [clientSecret, setClientSecret] = useState('');
  const [loading, setLoading] = useState(true);
  console.log("stripePromise",stripePromise);
  useEffect(() => {
    getClientSecret();
  }, []);

  const getClientSecret = async () => {
    console.log('in client');
    setLoading(true);
    const body = {
      amount: props.amount,
    };
    const { data } = await axios.post(trainingsApi.stripePaymentIntent, body);
    console.log('data  ',data);
    setClientSecret(data.clientSecret);
    setLoading(false);
  };

  return (
    <div>
      <Modal
        style={{ top: 50 }}
        visible={props.visible}
        footer={null}
        onCancel={props.handleCancelFunc}
      >
        {loading ? (
          <div> wait..</div>
        ) : (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
         <PaymentElement/>
          </Elements>
        )}
      </Modal>
    </div>
  );
};
export default Affirm;
